import { get, isEmpty } from "lodash";
import moment from "moment";
import { toast } from "react-toastify";
import PROPERTY_FORM from "../constants/PropertyForm";
import { getPropInpName } from "./functions";
import { dictionaryList } from "./language/index";
const defaultLanguage = "en";
const messages = dictionaryList[defaultLanguage].errors;

// global regex
const noHtmlRegex = /<\/?[^>]+(>|$)/g;
const onlyAlphbetRegex = /^[a-zA-Z]+(^\S.*)*$/;
const numberOnly = /^\d+$/;
var phoneRegex = /^[0-9]+$/;
// var passwordRegex = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[a-zA-Z]).{7,}$/;
const passwordRegex = /^(?=.*\d)(?=.*[a-zA-Z]).{8,}$/;
let newPasswordRegex = /^(?=.*[0-9])(?=.*[a-zA-Z])(?=\S+$).{8,}$/;
const decRegex = /^(0*[1-9][0-9]*(\.[0-9]*)?|0*\.[0-9]*[1-9][0-9]*)$/;
const regexUrl = /(?:https?):\/\/(\w+:?\w*)?(\S+)(:\d+)?(\/|\/([\w#!:.?+=&%!\-/]))?/;

const checkEmail = (value) => {
  if (
    !/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
      value
    )
  ) {
    return true;
  } else if (value.includes('"') || value.includes("'") || value.includes(",") || value.includes(" ")) {
    return true;
  } else {
    return false;
  }
};

export const loginValidator = (values, dictionary) => {
  let errors = {};

  if (!values.mobile_number) {
    errors.phone = dictionary.Please_enter_Mobile_Number;
  } else if (!phoneRegex.test(values.mobile_number)) {
    errors.phone = dictionary.phone;
  } else if (values.mobile_number.length < 4) {
    errors.phone = dictionary.phone;
  }

  if (!values.password) {
    errors.password = dictionary.Please_enter_Password;
  }

  return errors;
};

export const forgetValidator = (values, dictionary) => {
  let errors = {};
  if (!values.mobile_number) {
    errors.phone = dictionary.Please_enter_Mobile_Number;
  } else if (!phoneRegex.test(values.mobile_number)) {
    errors.phone = dictionary.phone;
  } else if (values.mobile_number.length < 4) {
    errors.phone = dictionary.phone;
  }

  return errors;
};

export const otpValidator = (values, dictionary) => {
  let errors = {};

  if (values.verification_code.length < 4) {
    errors.verification_code = dictionary.otp;
  }
  if (!values.verification_code) {
    errors.verification_code = dictionary.Please_enter_verification_code;
  }
  return errors;
};

export const resetOutValidator = (values, dictionary) => {
  let errors = {};

  if (!values.password) {
    errors.password = dictionary.Please_enter_Password;
  } else if (!passwordRegex.test(values.password)) {
    errors.password = dictionary.Password_must_contain_minimum;
  }
  if (!values.confirm_password) {
    errors.confirm_password = dictionary.Please_enter_the_confirm_Password;
  } else if (values.password !== values.confirm_password) {
    errors.confirm_password = dictionary.Passwords_do_not_match;
  }

  return errors;
};

export const signUpValidator = (values, dictionary) => {
  let errors = {};

  if (!values.first_name.trim()) {
    errors.first_name = dictionary.Please_enter_first_name;
  } else if (!/^[a-zA-Z\s]+$/.test(values.first_name)) {
    errors.first_name = dictionary.invalid;
  } else if (values.first_name.length > 20) {
    errors.first_name = dictionary.Please_use_less_than_characters;
  }
  else if ( values.first_name.length < 2) {
    errors.first_name = dictionary.Please_use_more_than_characters;
  }

  // if (!values.postalCode) {
  //   errors.postalCode = dictionary.Please_enter_PostalCode;
  // }

  if (!values.last_name.trim()) {
    errors.last_name = dictionary.Please_enter_last_name;
  } else if (!/^[a-zA-Z\s]+$/.test(values.last_name)) {
    errors.last_name = dictionary.invalid;
  } else if (values.last_name.length > 20) {
    errors.last_name = dictionary.Please_use_less_than_characters;
  }  else if ( values.last_name.length < 2) {
    errors.last_name = dictionary.Please_use_more_than_characters;
  }

  if (!values.phone) {
    errors.phone = dictionary.Enter_Mobile_Number;
  } else if (!phoneRegex.test(values.phone)) {
    errors.phone = dictionary.Enter_Mobile_Number;
  } else if (values.phone.length < 6) {
    errors.phone = dictionary.Enter_valid_mobile_number;
  }

  if (!values.email) {
    errors.email = dictionary.Please_enter_email;
  } else if (checkEmail(values.email)) {
    errors.email = dictionary.Please_enter_a_valid_email_address;
  }
  if (!values.password) {
    errors.password = dictionary.Please_enter_Password;
  } else if (!newPasswordRegex.test(values.password)) {
    errors.password = dictionary.passwordNew;
  }

  if (!values.confirm_password) {
    errors.confirm_password = dictionary.Please_enter_confirm_Password;
  } else if (values.password !== values.confirm_password) {
    errors.confirm_password = dictionary.Passwords_do_not_match;
  }

  if (!values.selectUser) {
    errors.selectUser = dictionary.Select_your_role_user_type;
  }

  if (!values.terms_check) {
    errors.terms_check = dictionary.Please_agree_to_the_terms;
  }

  return errors;
};

export const completeProfileValidator = (values) => {
  let errors = {};

  if (!values.restaurant_name) {
    errors.restaurant_name = messages.invalid;
  }
  if (!values.restaurant_about) {
    errors.restaurant_about = messages.invalid;
  }
  if (values.restaurant_about) {
    if (get(values, "restaurant_about", "").length > 500) {
      errors.restaurant_about = "Please use less than 500 characters";
    }
  }

  if (!values.restaurant_images[0]) {
    errors.restaurant_images = messages.invalid;
  }
  if (values.restaurant_images.length < 1) {
    errors.restaurant_images = messages.imagesLength;
  }
  // if (!values.restaurant_location) {
  //   errors.restaurant_location = messages.invalid;
  // }
  if (values.cuisines.length < 1) {
    errors.cuisines = messages.invalid;
  }
  if (!values.minimum_order) {
    errors.minimum_order = messages.invalid;
  }
  //  else if (!numberOnly.test(values.minimum_order)) {
  //   errors.minimum_order = messages.invalid;
  // }
  if (!values.distance_in_miles) {
    errors.distance_in_miles = messages.invalid;
  }
  if (!values.bank_name) {
    errors.bank_name = messages.invalid;
  }
  if (!values.account_holder_name) {
    errors.account_holder_name = messages.invalid;
  }
  if (!values.account_number) {
    errors.account_number = messages.invalid;
  }
  if (!values.ifsc) {
    errors.ifsc = messages.invalid;
  }
  // if (!values.working_hours[0].start_time
  //    && !values.working_hours[1].start_time
  //    && !values.working_hours[2].start_time
  //    && !values.working_hours[3].start_time
  //    && !values.working_hours[4].start_time
  //    && !values.working_hours[5].start_time
  //    ) {
  //   errors.working_hours = messages.invalid;
  // }

  // if (!values.working_hours[0].start_time && !values.working_hours[1].start_time && !values.working_hours[2].start_time && !values.working_hours[3].start_time && !values.working_hours[4].start_time && !values.working_hours[5].start_time && !values.working_hours[6].start_time) {
  //   errors.working_hours = "Please select at least one working day";
  // }
  // {
  //   values.working_hours.map((item, index) => {

  //     if (item.is_holyday == true ? (!item.start_time || !item.end_time) : "") {
  //       errors.working_hours = messages.selectStartEndTime;
  //     }
  //     if (!errors.working_hours) {
  //       if (item.is_holyday == true ? (item.start_time == item.end_time) : "") {
  //         errors.working_hours = messages.startEndTime;
  //       }
  //     }
  //     if (!errors.working_hours) {
  //       if (item.is_holyday == true ? (item.start_time >= item.end_time) : "") {
  //         errors.working_hours = "Start time should be greater than end time";
  //       }
  //     }
  //   })
  // }

  return errors;
};

export const completeUpdateProfileValidator = (values) => {
  let errors = {};

  // Personal Info
  if (!values.restaurant_name) {
    errors.restaurant_name = messages.invalid;
  }
  if (!values.restaurant_about) {
    errors.restaurant_about = messages.invalid;
  }
  if (values.restaurant_about) {
    if (get(values, "restaurant_about", "").length > 500) {
      errors.restaurant_about = "Please use less than 500 characters";
    }
  }
  if (!values.email) {
    errors.email = messages.invalid;
  }
  if (!values.mobile_number) {
    errors.mobile_number = messages.invalid;
  }
  if (!values.owner_name) {
    errors.owner_name = messages.invalid;
  }
  if (values.cuisines.length < 1) {
    errors.cuisines = messages.invalid;
  }
  if (!values.minimum_order) {
    errors.minimum_order = messages.invalid;
  }

  if (!values.distance_in_miles) {
    errors.distance_in_miles = messages.invalid;
  }

  // Bank Details
  if (!values.bank_name) {
    errors.bank_name = messages.invalid;
  }
  if (!values.account_holder_name) {
    errors.account_holder_name = messages.invalid;
  }
  if (!values.account_number) {
    errors.account_number = messages.invalid;
  }
  if (!values.ifsc) {
    errors.ifsc = messages.invalid;
  }
  if (!values.restaurant_images) {
    errors.restaurant_images = messages.invalid;
  }
  if (values.restaurant_images.length < 1) {
    errors.restaurant_images = messages.imagesLength;
  }
  // if (!values.working_hours[0].start_time
  //    && !values.working_hours[1].start_time
  //    && !values.working_hours[2].start_time
  //    && !values.working_hours[3].start_time
  //    && !values.working_hours[4].start_time
  //    && !values.working_hours[5].start_time
  //    ) {
  //   errors.working_hours = messages.invalid;
  // }

  // if (!values.working_hours[0].start_time && !values.working_hours[1].start_time && !values.working_hours[2].start_time && !values.working_hours[3].start_time && !values.working_hours[4].start_time && !values.working_hours[5].start_time && !values.working_hours[6].start_time) {
  //   errors.working_hours = "Please select at least one working day";
  // }
  // {
  //   values.working_hours.map((item, index) => {

  //     if (item.is_holyday == true ? (!item.start_time || !item.end_time) : "") {
  //       errors.working_hours = messages.selectStartEndTime;
  //     }
  //     if (!errors.working_hours) {
  //       if (item.is_holyday == true ? (item.start_time == item.end_time) : "") {
  //         errors.working_hours = messages.startEndTime;
  //       }
  //     }
  //     if (!errors.working_hours) {
  //       if (item.is_holyday == true ? (item.start_time >= item.end_time) : "") {
  //         errors.working_hours = "Start time should be greater than end time";
  //       }
  //     }
  //   })
  // }

  return errors;
};

export const additionalValidator = (values) => {
  let errors = {};

  if (!values.additional_item_name) {
    errors.additional_item_name = messages.invalid;
  }
  if (values.additional_item_name[0] === " ") {
    errors.additional_item_name = "Space is not allowed at starting.";
  }
  if (!values.additional_item_price) {
    errors.additional_item_price = messages.invalid;
  }
  if (values.additional_item_price[0] === "-") {
    errors.additional_item_price = "Negative value is not allowed for price";
  }

  return errors;
};

export const foodValidator = (values) => {
  let errors = {};

  if (values.food_image.length < 1) {
    errors.food_image = messages.invalid;
  }
  if (!values.food_name) {
    errors.food_name = messages.invalid;
  }
  if (!values.base_price) {
    errors.base_price = messages.invalid;
  }
  if (!values.food_type) {
    errors.food_type = messages.invalid;
  }
  if (!values.food_description) {
    errors.food_description = messages.invalid;
  }

  return errors;
};

export const offerValidatior = (values) => {
  let errors = {};

  // if (values.offer_image.length < 1) {
  //   errors.offer_image = messages.invalid;
  // }
  if (!values.offer_name) {
    errors.offer_name = messages.invalid;
  }
  if (!values.offer_code) {
    errors.offer_code = messages.invalid;
  } else if (values.offer_code.length > 15) {
    errors.offer_code = "Must be 15 characters or less";
  }
  if (!values.offer_validity.from) {
    errors.offer_validityfrom = messages.invalid;
  }
  if (!values.offer_validity.to) {
    errors.offer_validityto = messages.invalid;
  }
  if (!values.offer_discount_type) {
    errors.offer_discount_type = messages.invalid;
  }

  if (!values.offer_discount_amount) {
    errors.offer_discount_amount = messages.invalid;
  }

  if (!values.offer_min_valid_amount) {
    errors.offer_min_valid_amount = messages.invalid;
  }

  return errors;
};

export const reasonDescValidatior = (values) => {
  let errors = {};
  if (!values.reasonDesc) {
    errors.reasonDesc = messages.invalid;
  }
  return errors;
};

export const menuValidator = (values) => {
  let errors = {};
  if (!values.menu_title) {
    errors.menu_title = messages.invalid;
  }
  return errors;
};

export const locationValidator = (values) => {
  let errors = {};
  if (!values.restaurant_location) {
    errors.restaurant_location = messages.invalid;
  }
  return errors;
};

export const DetailsValidator = (values) => {
  let errors = {};
  if (!values.bio) {
    errors.bio = messages.invalid;
  }

  if (!values.address) {
    errors.address = messages.invalid;
  } else if (values.address.length > 30) {
    errors.address = "Please use less than 30 characters";
  }

  if (!values.license_number) {
    errors.license_number = messages.invalid;
  } else if (values.license_number.length > 20) {
    errors.license_number = "Please use less than 20 characters";
  }

  return errors;
};

export const AgentDetailsValidator = (values, dictionary) => {
  let errors = {};
  if (!values.bio) {
    errors.bio = dictionary.Please_enter_bio;
  } else if (values.bio.length > 350) {
    errors.bio = dictionary.Please_use_less_than_350_characters;
  }

  if (!values.address) {
    errors.address = dictionary.Please_enter_address;
  }

  if (values.license_number) {
    if (values.license_number.length > 20) {
      errors.license_number = dictionary.Please_use_less_than_characters;
    }
  }

  if (!values.buissness_since) {
    errors.buissness_since = dictionary.invalid;
  }

  if (!values.language_fluency) {
    errors.language_fluency = dictionary.invalid;
  }

  if (values.website) {
    if (!regexUrl.test(values.website)) {
      errors.website = dictionary.Please_enter_the_Valid_Website_Link;
    }
  }

  if (values.facebook) {
    if (!regexUrl.test(values.facebook)) {
      errors.facebook = dictionary.Please_enter_the_Valid_Facebook_Link;
    }
  }

  if (values.blog) {
    if (!regexUrl.test(values.blog)) {
      errors.blog = dictionary.Please_enter_the_Valid_Blog_Link;
    }
  }

  if (values.linkedin) {
    if (!regexUrl.test(values.linkedin)) {
      errors.linkedin = dictionary.Please_enter_the_Valid_Linkedin_Link;
    }
  }

  return errors;
};

const validateField = (inp, vals, errs, dictionary) => {
  const val = vals[inp.inpName];

  const isTextType = [PROPERTY_FORM.INPUT_TYPE.TEXT, PROPERTY_FORM.INPUT_TYPE.TEXTAREA].includes(+inp.input_type);
  const isAlphaType = isTextType && +inp.input_field_type === PROPERTY_FORM.INPUT_FIELD_TYPE.ALPHABET;
  const isNumType = isTextType && +inp.input_field_type === PROPERTY_FORM.INPUT_FIELD_TYPE.NUMBER;
  const isAlphaNumType = isTextType && +inp.input_field_type === PROPERTY_FORM.INPUT_FIELD_TYPE.ALPHANUMERIC;
  const isDropdownType = +inp.input_type === PROPERTY_FORM.INPUT_TYPE.DROPDOWN;
  const isDateType = +inp.input_type === PROPERTY_FORM.INPUT_TYPE.DATE;
  const isBtnType = +inp.input_type === PROPERTY_FORM.INPUT_TYPE.BUTTON;

  if (isTextType) {
    if (isAlphaNumType || isAlphaType) {
      if (isEmpty(val)) {
        if (!+inp.input_is_optional) {
          errs[inp.inpName] = `${inp.input_name} ${dictionary?.is_required}`;
        }
      } else if (val.length > +inp.input_max_length) {
        errs[inp.inpName] = `${inp.input_name} ${dictionary?.cant_exceed} ${+inp.input_max_length} ${dictionary?.chars}`;
      } else if (isAlphaType) {
        if (/[0-9@]/.test(val)) {
          errs[inp.inpName] = `${inp.input_name} ${dictionary?.cant_contain_number}`;
        }
      }
    } else if (isNumType) {
      if (isEmpty(String(val))) {
        if (!+inp.input_is_optional) {
          errs[inp.inpName] = `${inp.input_name} ${dictionary?.is_required}`;
        }
      } else if (typeof inp.min_value === "number" && val < inp.min_value) {
        errs[inp.inpName] = `${inp.input_name} can't be smaller than ${inp.min_value}`;
      } else if (typeof inp.max_value === "number" && val > inp.max_value) {
        errs[inp.inpName] = `${inp.input_name} can't be greater than ${inp.max_value}`;
      }
    }
  } else if (isDropdownType) {
    if (isEmpty(val)) {
      if (!+inp.input_is_optional) {
        errs[inp.inpName] = `${inp.input_name} ${dictionary?.is_required}`;
      }
    } else if (!inp.single) {
      if (inp.dropdown_value_limit > 1 && val.length > inp.dropdown_value_limit) {
        errs[inp.inpName] = `${inp.input_name} can't exceed ${inp.dropdown_value_limit} selections`;
      } else if (inp.dropdown_value_limit === -1 && val.length !== inp.dropdown_value_limit) {
        errs[inp.inpName] = `All options are mandatory in ${inp.input_name}`;
      }
    }
  } else if (isDateType) {
    if (isEmpty(val)) {
      if (!+inp.input_is_optional) {
        errs[inp.inpName] = `${inp.input_name} ${dictionary?.is_required}`;
      }
    } else if (inp._id === "635caddfc8fc739cc7950acd") {
      if (moment(val, "YYYY-MM-DD").isSameOrBefore(moment(vals.yearBuildVal), "days")) {
        errs[inp.inpName] = `Year remodeled date can't be less than Year built date`;
      }else if (moment(val, "YYYY-MM-DD").isAfter(moment(), "day")) {
        errs[inp.inpName] = `Year remodeled date can't be in the future`;
      }
    } else if (inp._id === "635cb42ea34c5e5c58f23b6e") {
      if (moment(val, "YYYY-MM-DD").isSameOrBefore(moment(vals.listDate), "days")) {
        errs[inp.inpName] = `Year Expiration date can't be less than List date`;
      }
    } else if (inp.is_future_date_accept && moment(val, "YYYY-MM-DD").isSameOrBefore(moment(), "days")) {
      errs[inp.inpName] = `${inp.input_name} can be future date only`;
    } else if (!inp.is_future_date_accept && moment(val, "YYYY-MM-DD").isAfter(moment(), "days")) {
      errs[inp.inpName] = `${inp.input_name} can't be future date`;
    }
  }

  const valMod = val instanceof Array ? val : isEmpty(val) ? [] : [val];

  if (!+inp.input_is_optional) {
    if (inp.linkedInp && valMod.some((v) => v?.value === inp.dropdown_condition_value_id)) {
      validateField(inp.linkedInp, vals, errs);
    }

    if (inp.inpColl?.length && valMod.some((v) => v?.value === inp.dropdown_condition_value_id)) {
      inp.inpColl.map((collInp) => validateField(collInp, vals, errs));
    }
  }

  if (inp.revInpColl?.length && !valMod.some((v) => v?.value === inp.dropdown_condition_value_id) && !isEmpty(val)) {
    inp.revInpColl.map((collInp) => validateField(collInp, vals, errs));
  }
};

export const validatePostAProperty = (
  fieldsData,
  {
    s1__saleOrLease,
    s1__leaseTerms,
    s1__type,
    s1__name,
    s1__desc,
    s1__images,
    s1__documents,
    s1__country,
    s1__state,
    s1__city,
    s1__address,
    s1__street,
    s1__building,
    s1__zip,
    s1__direction,
    ...vals
  },
  dictionary
) => {
  let errs = {};

  if (isEmpty(s1__saleOrLease)) {
    errs.s1__saleOrLease = dictionary?.Select_Sale_or_Lease;
  } else if (s1__saleOrLease === "Lease" && isEmpty(s1__leaseTerms)) {
    errs.s1__leaseTerms = dictionary?.Enter_Date;
  }

  if (isEmpty(s1__type)) {
    errs.s1__type = dictionary?.Select_Property_Type;
  }

  if (isEmpty(s1__name)) {
    errs.s1__name = dictionary?.Enter_Property_Name;
  } else if (s1__name.length > 30) {
    errs.s1__name = dictionary?.Property_Name_cant_exceed;
  }

  if (isEmpty(s1__desc)) {
    errs.s1__desc = dictionary?.Enter_Property_Description;
  } else if (s1__desc.length > 240) {
    errs.s1__desc = dictionary?.Property_Description_cant_exceed;
  }

  if (isEmpty(s1__images) || s1__images.length < PROPERTY_FORM.MIN_IMGS) {
    // errs.s1__images = dictionary?.Upload_at_least + PROPERTY_FORM.MIN_IMGS + " " + dictionary?.images;
    errs.s1__images = dictionary?.Upload_atleat_2_img;
  } else if (s1__images.length > PROPERTY_FORM.MAX_IMGS) {
    errs.s1__images = dictionary?.Images_exceeded_max_limit_of + PROPERTY_FORM.MAX_IMGS + dictionary?.images;
  }

  if (isEmpty(s1__documents)) {
    errs.s1__documents = dictionary?.Upload_at_least_document;
  } else if (s1__documents.length > PROPERTY_FORM.MAX_DOCS) {
    errs.s1__documents = dictionary?.Documents_exceeded_max_limit + PROPERTY_FORM.MAX_DOCS + dictionary?.documents;
  }

  Object.values(PROPERTY_FORM.PROPERTY_STATUS).forEach((status) => {
    if (vals["s1__status__" + status] && isEmpty(vals["s1__statusDate__" + status])) {
      errs["s1__statusDate__" + status] = dictionary?.Enter_Date;
    }
  });

  const expiredStatus = "s1__status__" + PROPERTY_FORM.PROPERTY_STATUS.EXPIRED;
  const expiredStatusDate = "s1__statusDate__" + PROPERTY_FORM.PROPERTY_STATUS.EXPIRED;

  if (
    !errs[expiredStatus] &&
    vals[expiredStatus] &&
    moment(vals[expiredStatusDate], "DD/MM/YYYY").isSameOrBefore(moment(), dictionary?.days)
  ) {
    errs[expiredStatusDate] = dictionary?.Date_must_be_a_future;
  }

  if (isEmpty(s1__country)) {
    errs.s1__country = dictionary?.Enter_Country;
  }

  // if (isEmpty(s1__state)) {
  //   errs.s1__state = "Enter State/Province";
  // }

  // if (isEmpty(s1__city)) {
  //   errs.s1__city = "Enter City";
  // }

  if (isEmpty(s1__address)) {
    errs.s1__address = dictionary?.Enter_Address;
  } else if (s1__address.length > 40) {
    errs.s1__address = dictionary?.Address_cant_exceed;
  }

  if (isEmpty(s1__street)) {
    errs.s1__street = dictionary?.Enter_Street_Name;
  } else if (s1__street.length > 20) {
    errs.s1__street = dictionary?.Street_Name_cant_exceed;
  }

  if (isEmpty(s1__building)) {
    errs.s1__building = dictionary?.Enter_Building;
  } else if (s1__building.length > 20) {
    errs.s1__building = dictionary?.Building_cant_exceed;
  }

  if (isEmpty(s1__zip)) {
    errs.s1__zip = dictionary?.Enter_ZIP_Code;
  } else if (s1__zip.length > 8) {
    errs.s1__zip = dictionary?.ZIP_code_exceed;
  }

  if (isEmpty(s1__direction)) {
    errs.s1__direction = dictionary?.Enter_Direction;
  } else if (s1__direction.length > 20) {
    errs.s1__direction = dictionary?.Direction_cant_exceed;
  }

  let yearBuildVal, listDate;

  fieldsData?.stepGrps.forEach((stp) => {
    stp.forEach((grp) => {
      grp.inputs.forEach((inp) => {
        if (inp._id === "635cadc8c8fc739cc7950acb") {
          yearBuildVal = vals[inp.inpName];
        } else if (inp._id === "635cb420a34c5e5c58f23b6c") {
          listDate = vals[inp.inpName];
        }
        validateField(inp, { ...vals, yearBuildVal, listDate }, errs, dictionary);
      });
    });
  });

  return errs;
};

export const validatePostPropertyColl = (inps, vals, dictionary) => {
  let errs = {};
  inps.forEach((inp) => validateField(inp, vals, errs, dictionary));
  return errs;
};



export const userDetailsValidator = (values, dictionary) => {
  let errors = {};

  if (!values.first_name.trim()) {
    errors.first_name = dictionary.Please_enter_first_name;
    toast.error(dictionary.Please_enter_first_name);
  } 
  else if (values.first_name.length > 20) {
    errors.first_name = dictionary.Please_use_less_than_characters;
    toast.error(dictionary.Please_use_less_than_characters);
  }
  else if (values.first_name.length < 2) {
    errors.first_name = dictionary.Please_use_more_than_characters;
    toast.error(dictionary.Please_use_more_than_characters);
  }
  

  if (!values.last_name) {
    errors.last_name = dictionary.Please_enter_last_name;
    toast.error(dictionary.Please_enter_last_name);
  } else if (!onlyAlphbetRegex.test(values.last_name)) {
   
  } else if (values.last_name.length > 20) {
    errors.last_name = dictionary.Please_use_less_than_characters;
    toast.error(dictionary.Please_use_less_than_characters);
  }else if (values.last_name.length < 2) {
    errors.last_name = dictionary.Please_use_more_than_characters;
    toast.error(dictionary.Please_use_more_than_characters);
  }

  // Show errors in toast messages
  // Object.values(errors).forEach(errorMessage => {
  //   toast.error(errorMessage);
  // });

  return errors;
};

export const ServiceAreaValidator = (values, dictionary) => {
  let errors = {};

  if (!values.zip_code) {
    errors.zip_code = dictionary.Zipcode_is_required;
  } else if (values.zip_code.length > 6) {
    errors.zip_code = dictionary.Invalid_Zipcode;
  } else if (values.zip_code <= 0) {
    errors.zip_code = dictionary.Invalid_Zipcode;
  }

  if (!values.area_percent) {
    errors.area_percent = dictionary.Area_Percent_is_required;
  } else if (values.area_percent > 100) {
    errors.area_percent = dictionary.Area_Percent_cant_be_more_than;
  } else if (values.area_percent <= 0) {
    errors.area_percent = dictionary.Area_Percent_must_be_greater_than;
  }

  if (!values.from_date) {
    errors.from_date = dictionary.From_Date_is_required;
  }

  if (!values.to_date) {
    errors.to_date = dictionary.To_Date_is_required;
  }

  return errors;
};

export const agentContactValidator = (values, dictionary) => {
  let errors = {};

  if (!values.full_name.trim()) {
    errors.full_name = dictionary.Please_enter_full_name;
  } else if (!/^[a-zA-Z\s]+$/.test(values.full_name)) {
    errors.full_name = dictionary.invalid;
  } else if (values.full_name.length > 20) {
    errors.full_name = dictionary.Please_use_less_than_characters;
  } else if (values.full_name.length < 2) {
    errors.full_name = dictionary.Please_use_more_than_characters;
    
  }

  if (!values.email_id) {
    errors.email_id = dictionary.Please_enter_email;
  } else if (checkEmail(values.email_id)) {
    errors.email_id = dictionary.Please_enter_a_valid_email_address;
  }

  if (!values.phone) {
    errors.phone = dictionary.Enter_Mobile_Number;
  } else if (!phoneRegex.test(values.phone)) {
    errors.phone = dictionary.Enter_Mobile_Number;
  } else if (values.phone.length < 6) {
    errors.phone = dictionary.Enter_valid_mobile_number;
  }

  if (!values.message) {
    errors.message = dictionary.Please_enter_the_message;
  }

  return errors;
};

export const changePasswordValidator = (values, dictionary) => {
  let errors = {};

  if (!values.old_password) {
    errors.old_password = dictionary.Please_enter_the_old_Password;
  } else if (!passwordRegex.test(values.old_password)) {
    errors.old_password = dictionary.Password_must_contain_minimum;
  }

  if (!values.new_password) {
    errors.new_password = dictionary.Please_enter_the_new_Password;
  } else if (!passwordRegex.test(values.new_password)) {
    errors.new_password = dictionary.Password_must_contain_minimum;
  }
  if (!values.confirm_password) {
    errors.confirm_password = dictionary.Please_enter_the_confirm_Password;
  } else if (values.confirm_password !== values.confirm_password) {
    errors.confirm_password = dictionary.Passwords_do_not_match;
  }

  return errors;
};
